// // new code current proper work ye sahi hai code but na client ne out of stock wala add karne ke phele wala code jo sahi hai iske niche same code copy karke out of stock add akiya hai new api se bhai
// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate, Link } from 'react-router-dom';
// import Layout from '../../Layout/Layout';
// import Footer from '../../Layout/Footer';
// import DetailsSection2dynamic from './DetailsSection2dynamic';
// import { useCart } from '../../../Context/CartContext';
// import { useWishlist } from '../../../Context/WishlistContext';
// import { AddToCart } from "../Products/AddtoCart";
// import FooterNew from '../../Layout/FooterNew';
// import CategorySection from '../HomePage/CategorySection';
// import SEO from '../../SEO';

// const BASE_URL = "https://ecom.cyberathon.com";

// const getCartToken = () => {
//   let token = localStorage.getItem("cart_token");
//   if (!token) {
//     token = crypto.randomUUID();
//     localStorage.setItem("cart_token", token);
//   }
//   return token;
// };

// function DetailsSection3() {
//   const normalizeId = (value) => {
//     if (!value) return null;
//     return value.includes("-") ? value.split("-").pop() : value;
//   };

//   const { prod_id } = useParams();
//   const finalId = normalizeId(prod_id);
//   const navigate = useNavigate();

//   const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();
//   const { wishlistItems, toggleWishlist } = useWishlist();

//   const [added, setAdded]               = useState(false);
//   const [qty, setQty]                   = useState(1);
//   const [selectedSize, setSelectedSize] = useState(null);
//   const [selectedImage, setSelectedImage] = useState("");
//   const [sizes, setSizes]               = useState([]);

//   // 14july2026 3pecie, 5 pecie ke liye add hona client ne bola
//   // ★ NEW: Quantity Set states
// const [priceType, setPriceType] = useState("simple");
// const [quantityVariants, setQuantityVariants] = useState([]);
// const [selectedQtyIndex, setSelectedQtyIndex] = useState(0);

//   const hasSizes = sizes?.length > 0;

//   const [BannerUser, setBannerUser] = useState({
//     Product_image: [],
//     Product_name: "",
//     category_id: "",
//     discription: "",
//     old_price: "",
//     current_price: "",
//     discount: "",
//     rating: "",
//     pdetails_sheading: "",
//     large_description: "",
//     stock_status: "",
//     prod_id: "",
//     product_type: "product",
//     weight: 0,
//     // ★ NEW
//     price_type: "simple",
//     quantity_variants: [],
//   });

//   const [relatedProducts, setRelatedProducts] = useState([]);
//   const [showReviewModal, setShowReviewModal] = useState(false);
//   const [reviewForm, setReviewForm] = useState({
//     rating: "", review_title: "", review_text: "", review_images: []
//   });
//   const [reviews, setReviews] = useState([]);
//   const [seoData, setSeoData] = useState({});

//   useEffect(() => {
//     const fetchSeo = async () => {
//       try {
//         const response = await axios.post(`${BASE_URL}/index.php/Api/get_seo_by_page`, { page_name: 'product_detail' });
//         if (response.data.status === 'true') {
//           const data = response.data.data;
//           setSeoData({
//             title: data.meta_title,
//             description: data.meta_description,
//             keywords: data.meta_keywords,
//             canonical: data.canonical_url,
//           });
//         }
//       } catch (error) {
//         console.error('SEO fetch error:', error);
//       }
//     };
//     fetchSeo();
//   }, []);

//   useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, []);

//   /* CHECK IF PRODUCT ALREADY IN CART */
//   useEffect(() => {
//     const checkIfAdded = async () => {
//       const userId    = sessionStorage.getItem("userId");
//       const cartToken = !userId ? localStorage.getItem("cart_token") : null;
//       if (!userId && !cartToken) return;
//       try {
//         const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//           user_id:    userId    ? userId    : null,
//           cart_token: cartToken ? cartToken : null,
//         });
//         if (res.data.status) {
//           const prodIds = res.data.cart_items.map(i => String(i.prod_id));
//           if (prodIds.includes(String(finalId))) setAdded(true); // ✅ finalId
//         }
//       } catch (err) { console.error(err); }
//     };
//     checkIfAdded();
//   }, [finalId]); // ✅ finalId

//   /* FETCH PRODUCT --> iss code size option hide ho gaya tha*/
// //   useEffect(() => {
// //   const fetchProduct = async () => {
// //     try {
// //       let response;

// //       // ✅ NORMAL ID
// //       if (!prod_id.includes("-")) {
// //         response = await axios.post(
// //           `${BASE_URL}/index.php/Api/get_by_id_create_product`,
// //           { prod_id: finalId }
// //         );
// //       }

// //       // ✅ SLUG CASE
// //       else {
// //         const slug = prod_id
// //           .toLowerCase()
// //           .split("-")
// //           .slice(0, -1)
// //           .join(" ");

// //         const res = await axios.get(
// //           `${BASE_URL}/index.php/Api/list_get_product`
// //         );

// //         const products = res.data.products || [];

// //         const matched = products.find((p) => {
// //           const name = p.Product_name.toLowerCase();
// //           return slug.split(" ").every(word => name.includes(word));
// //         });

// //         if (!matched) {
// //           console.log("No match found:", slug);
// //           navigate("/products");
// //           return;
// //         }

// //         response = await axios.post(
// //           `${BASE_URL}/index.php/Api/get_by_id_create_product`,
// //           { prod_id: matched.prod_id }
// //         );
// //       }

// //       if (response?.data?.products?.length > 0) {
// //         setBannerUser(response.data.products[0]);
// //       }

// //     } catch (error) {
// //       console.error(error);
// //     }
// //   };

// //   fetchProduct();
// // }, [prod_id]);

// /* FETCH PRODUCT --> size option hide ho gaya tha wo laya iss code se*/
//   useEffect(() => {
//   const fetchProduct = async () => {
//     try {
//       let productData = [];

//       // ✅ NORMAL ID
//       if (!prod_id.includes("-")) {
//         const response = await axios.post(
//           `${BASE_URL}/index.php/Api/get_by_id_create_product`,
//           { prod_id: finalId }
//         );
//         productData = response.data.products || [];
//       }

//       // ✅ SLUG CASE
//       else {
//         const slug = prod_id
//           .toLowerCase()
//           .split("-")
//           .slice(0, -1)
//           .join(" ");

//         const res = await axios.get(
//           `${BASE_URL}/index.php/Api/list_get_product`
//         );

//         const products = res.data.products || [];

//         const matched = products.find((p) => {
//           const name = p.Product_name.toLowerCase();
//           return slug.split(" ").every(word => name.includes(word));
//         });

//         if (!matched) {
//           console.log("No match found:", slug);
//           navigate("/products");
//           return;
//         }

//         const response = await axios.post(
//           `${BASE_URL}/index.php/Api/get_by_id_create_product`,
//           { prod_id: matched.prod_id }
//         );
//         productData = response.data.products || [];
//       }

//       // nikita code 3pecie 5 pecie logic add karne ke phele wala code
//       // ✅ SIZE LOGIC (purane code se restore kiya — yahi missing tha)
//       // if (productData.length > 0) {
//       //   const firstProduct = productData[0];
//       //   const validSizes = productData.filter(
//       //     p => p.size !== null && p.size !== "" && p.size !== "0"
//       //   );

//       //   setBannerUser({
//       //     ...firstProduct,
//       //     current_price: validSizes.length > 0 ? validSizes[0].variant_price : firstProduct.current_price,
//       //     old_price:     validSizes.length > 0 ? validSizes[0].variant_old_price : firstProduct.old_price,
//       //   });

//       //   if (validSizes.length > 0) {
//       //     setSizes(validSizes);
//       //     setSelectedSize(null);
//       //   } else {
//       //     setSizes([]);
//       //     setSelectedSize(null);
//       //   }
//       // }

//       // 14july2026 3pecie 5 pecie add karne ko bola tha client ne
//             if (productData.length > 0) {
//         const firstProduct = productData[0];

//         // ★ STEP 1: Check price_type
//         const pType = firstProduct.price_type || "simple";
//         setPriceType(pType);

//         // ★ STEP 2: Parse quantity_variants if string
//         let qv = firstProduct.quantity_variants || [];
//         if (typeof qv === "string") {
//           try { qv = JSON.parse(qv); } catch { qv = []; }
//         }
//         if (!Array.isArray(qv)) qv = [];

//         // ★ STEP 3: SIZE VARIANT logic (purana — unchanged)
//         const validSizes = productData.filter(
//           p => p.size !== null && p.size !== "" && p.size !== "0"
//         );

//         // ★ STEP 4: Set BannerUser based on price type
//         if (pType === "quantity_set" && qv.length > 0) {
//           // Quantity set — first variant ki price as default
//           setBannerUser({
//             ...firstProduct,
//             current_price: qv[0].current_price,
//             old_price: qv[0].old_price || "",
//             quantity_variants: qv,
//           });
//           setQuantityVariants(qv);
//           setSelectedQtyIndex(0);
//           setSizes([]);
//           setSelectedSize(null);
//         } else if (validSizes.length > 0) {
//           // Size variant — purana flow
//           setBannerUser({
//             ...firstProduct,
//             current_price: validSizes[0].variant_price,
//             old_price: validSizes[0].variant_old_price,
//           });
//           setSizes(validSizes);
//           setSelectedSize(null);
//           setQuantityVariants([]);
//           setSelectedQtyIndex(0);
//         } else {
//           // Simple price — purana flow
//           setBannerUser({ ...firstProduct });
//           setSizes([]);
//           setSelectedSize(null);
//           setQuantityVariants([]);
//           setSelectedQtyIndex(0);
//         }
//       }

//     } catch (error) {
//       console.error(error);
//     }
//   };

//   fetchProduct();
// }, [prod_id]);

//   /* FETCH REVIEWS */
//   useEffect(() => {
//     const fetchReviews = async () => {
//       try {
//         const res = await axios.post(`${BASE_URL}/index.php/Api/list_product_reviews`, { prod_id: finalId }); // ✅ finalId
//         if (res.data.status === "true") setReviews(res.data.data);
//       } catch (error) { console.error(error); }
//     };
//     fetchReviews();
//   }, [finalId]); // ✅ finalId

//   /* SET FIRST IMAGE */
//   useEffect(() => {
//     if (BannerUser.Product_image?.length > 0) setSelectedImage(BannerUser.Product_image[0]);
//   }, [BannerUser.Product_image]);

//   /* FETCH SIMILAR PRODUCTS */
//   useEffect(() => {
//     if (!BannerUser.category_id) return;
//     const fetchRelatedProducts = async () => {
//       try {
//         const res = await axios.get(`${BASE_URL}/index.php/Api/list_get_product`);
//         if (res.data.products) {
//           const filtered = res.data.products.filter(
//             (item) =>
//               String(item.category_id) === String(BannerUser.category_id) &&
//               String(item.prod_id)     !== String(finalId) // ✅ finalId
//           );
//           setRelatedProducts(filtered);
//         }
//       } catch (error) { console.error(error); }
//     };
//     fetchRelatedProducts();
//   }, [BannerUser.category_id, finalId]); // ✅ finalId

//   /* QTY CONTROLS */
//   const increaseQty = () => setQty(prev => prev + 1);
//   const decreaseQty = () => { if (qty > 1) setQty(prev => prev - 1); };

//   const QtyBlock = (
//     <div className="qty-wrapper">
//       <button type="button" className="qty-btn-action" onClick={decreaseQty} disabled={qty <= 1}>−</button>
//       <input
//         type="text" value={qty} inputMode="numeric" pattern="[0-9]*" className="qty-input"
//         onChange={(e) => {
//           const val = e.target.value.replace(/\D/g, "");
//           if (val === "") setQty(""); else setQty(Math.max(1, Number(val)));
//         }}
//         onBlur={() => { if (!qty || qty < 1) setQty(1); }}
//       />
//       <button type="button" className="qty-btn-action" onClick={increaseQty}>+</button>
//     </div>
//   );

//   /* STARS */
//   const renderStars = (rating) => {
//     const stars = [];
//     const fullStars  = Math.floor(rating);
//     const hasHalf    = rating % 1 !== 0;
//     const emptyStars = 5 - Math.ceil(rating);
//     for (let i = 0; i < fullStars; i++)  stars.push(<i key={"f"+i} className="fa-solid fa-star text-warning"></i>);
//     if (hasHalf)                          stars.push(<i key="half"  className="fa-solid fa-star-half-stroke text-warning"></i>);
//     for (let i = 0; i < emptyStars; i++) stars.push(<i key={"e"+i} className="fa-regular fa-star text-warning"></i>);
//     return stars;
//   };

//   /* BUY NOW */
//   const handleBuyNow = () => {
//     const userId = sessionStorage.getItem("userId");

//     // discount nhi calculate ho raha tha nikita code
//     // const buyNowProduct = {
//     //   prod_id: BannerUser.prod_id,
//     //   Product_name: BannerUser.Product_name,
//     //   current_price: selectedSize?.variant_price || BannerUser.current_price,
//     //   qty: qty,
//     //   Product_image: BannerUser.Product_image?.[0],
//     //   product_type: BannerUser.product_type || "product",
//     //   weight: parseFloat(BannerUser.weight) || 0,
//     // };

//     // 02-07-2026 client ke discout add karne hai bolne ke bad wala code
// //     const buyNowProduct = {
// //   prod_id: BannerUser.prod_id,
// //   Product_name: BannerUser.Product_name,
// //   current_price: selectedSize?.variant_price || BannerUser.current_price,
// //   old_price: selectedSize?.variant_old_price || BannerUser.old_price,
// //   discount: Number(BannerUser.discount) || 0,
// //   qty: qty,
// //   Product_image: BannerUser.Product_image?.[0],
// //   product_type: BannerUser.product_type || "product",
// //   weight: parseFloat(BannerUser.weight) || 0,
// // };

// //     if (selectedSize?.size_id) {
// //       buyNowProduct.size = selectedSize.size;
// //       buyNowProduct.size_id = selectedSize.size_id;
// //     }

// // 14-july-2026 client ke discout add karne hai bolne ke bad wala code
//     // ★ Selected price: size ya quantity set ya simple
//     const selectedPrice = selectedSize?.variant_price
//       || (priceType === "quantity_set" && quantityVariants[selectedQtyIndex]?.current_price)
//       || BannerUser.current_price;

//     const selectedOldPrice = selectedSize?.variant_old_price
//       || (priceType === "quantity_set" && quantityVariants[selectedQtyIndex]?.old_price)
//       || BannerUser.old_price;

//     const buyNowProduct = {
//   prod_id: BannerUser.prod_id,
//   Product_name: BannerUser.Product_name,
//   current_price: selectedPrice,
//   old_price: selectedOldPrice,
//   discount: Number(BannerUser.discount) || 0,
//   qty: qty,
//   Product_image: BannerUser.Product_image?.[0],
//   product_type: BannerUser.product_type || "product",
//   weight: parseFloat(BannerUser.weight) || 0,
//   // ★ NEW: Quantity set info pass karo
//   price_type: priceType,
//   selected_quantity_set: priceType === "quantity_set" ? quantityVariants[selectedQtyIndex] : null,
// };

//     if (selectedSize?.size_id) {
//       buyNowProduct.size = selectedSize.size;
//       buyNowProduct.size_id = selectedSize.size_id;
//     }

//     if (userId) {
//       navigate("/Bill", { state: { buyNow: true, product: buyNowProduct } });
//     } else {
//       setRedirectAfterLogin("/Bill");
//       sessionStorage.setItem("buyNowProduct", JSON.stringify(buyNowProduct));
//       setShowLogin(true);
//     }
//   };

//   /* ADD TO CART */
//   const handleAddToCart = async () => {
//     const userId    = sessionStorage.getItem("userId");
//     const cartToken = !userId ? getCartToken() : null;

//     try {
//       const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id:    userId    ? userId    : null,
//         cart_token: cartToken ? cartToken : null,
//       });

//       let cartItem = null;
//       if (res.data.status) {
//         cartItem = res.data.cart_items.find(i => String(i.prod_id) === String(finalId)); // ✅ finalId
//       }

//       // Nikita code 3pecie 5 pecie logic add karne ke phele wala code
//       // const payload = {
//       //   user_id: userId ? userId : null,
//       //   cart_token: cartToken ? cartToken : null,
//       //   prod_id: BannerUser.prod_id,
//       //   quantity: qty,
//       //   current_price: selectedSize?.variant_price || BannerUser.current_price,
//       //   old_price: selectedSize?.variant_old_price || BannerUser.old_price,
//       // };

//       // if (selectedSize?.size_id) {
//       //   payload.size = selectedSize.size;
//       //   payload.size_id = selectedSize.size_id;
//       // }

//             // ★ Selected price
//       const cartSelectedPrice = selectedSize?.variant_price
//         || (priceType === "quantity_set" && quantityVariants[selectedQtyIndex]?.current_price)
//         || BannerUser.current_price;

//       const cartSelectedOldPrice = selectedSize?.variant_old_price
//         || (priceType === "quantity_set" && quantityVariants[selectedQtyIndex]?.old_price)
//         || BannerUser.old_price;

//       const payload = {
//         user_id: userId ? userId : null,
//         cart_token: cartToken ? cartToken : null,
//         prod_id: BannerUser.prod_id,
//         quantity: qty,
//         current_price: cartSelectedPrice,
//         old_price: cartSelectedOldPrice,
//       };

//       if (selectedSize?.size_id) {
//         payload.size = selectedSize.size;
//         payload.size_id = selectedSize.size_id;
//       }

//       // ★ Quantity set info
//       if (priceType === "quantity_set" && quantityVariants[selectedQtyIndex]) {
//         payload.price_type = "quantity_set";
//         payload.selected_quantity_set = quantityVariants[selectedQtyIndex];
//       }

//       if (cartItem) {
//         await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
//           cart_id:   cartItem.cart_id,
//           quantity:  qty,
//           user_id:   userId    ? userId    : null,
//           cart_token: cartToken ? cartToken : null,
//         });
//       } else {
//         await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, payload);
//         setCartCount(prev => prev + 1);
//       }
//       setAdded(true);
//     } catch (error) { console.error(error); }
//   };

//   /* REVIEW HANDLERS */
//   const handleReviewChange = (e) => {
//     const { name, value } = e.target;
//     setReviewForm(prev => ({ ...prev, [name]: value }));
//   };

//   const handleReviewImages = (e) => {
//     const filesArray = Array.from(e.target.files);
//     setReviewForm(prev => ({ ...prev, review_images: filesArray }));
//   };

//   const handleSubmitReview = async () => {
//     const userId = sessionStorage.getItem("userId");
//     if (!userId)            { alert("Please login first"); return; }
//     if (!reviewForm.rating) { alert("Please select a rating"); return; }
//     try {
//       const formData = new FormData();
//       formData.append("prod_id",      finalId); // ✅ finalId
//       formData.append("user_id",      userId);
//       formData.append("rating",       reviewForm.rating);
//       formData.append("review_title", reviewForm.review_title || "");
//       formData.append("review_text",  reviewForm.review_text  || "");
//       if (reviewForm.review_images?.length > 0) {
//         reviewForm.review_images.forEach(img => formData.append("review_images[]", img, img.name));
//       }
//       const response = await axios.post(
//         `${BASE_URL}/index.php/Api/add_product_reviews`,
//         formData,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );
//       if (response.data.status === "true") {
//         alert("Review Added Successfully!");
//         const res = await axios.post(`${BASE_URL}/index.php/Api/list_product_reviews`, { prod_id: finalId }); // ✅ finalId
//         if (res.data.status === "true") setReviews(res.data.data);
//         setShowReviewModal(false);
//         setReviewForm({ rating: "", review_title: "", review_text: "", review_images: [] });
//       } else {
//         alert("Failed to add review. Try again.");
//       }
//     } catch (error) { console.error("Review submit error:", error); alert("Something went wrong!"); }
//   };

//   const handleViewAll = () => {
//     if (!BannerUser.category_name) return;
//     navigate("/products", { state: { categoryKey: BannerUser.category_name.replaceAll(" ", "") } });
//   };

//   return (
//     <>
//      <SEO
//     title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
//     description={seoData.description || "Explore our wide collection of E-Books on programming, design, and more."}
//     keywords={seoData.keywords || "ebooks, shopindia, buy ebooks, online books, programming ebooks, design ebooks"}
//     canonical={seoData.canonical || "https://www.shopindia.com/ebooks"}
//   />

//       <Layout />

//       <div className="container-fluid pt-5 pb-2">
//         <div className="row align-items-start">

//           {/* IMAGES */}
//           <div className="col-12 col-lg-5 col-md-6 position-relative">
//             <div>
//               <div className='product-image-wrapper'>
//                 <div className="thumbnail-column">
//                   {BannerUser.Product_image?.map((img, index) => (
//                     <img key={index} src={`${BASE_URL}/${img}`} className={`thumb-img ${selectedImage === img ? "active-thumb" : ""}`} onClick={() => setSelectedImage(img)} alt="thumb" />
//                   ))}
//                 </div>
//                 <div className="big-image-wrapper">
//                   <img src={`${BASE_URL}/${selectedImage}`} alt="product" className="img-fluid imgsize" />
//                 </div>
//               </div>
//             </div>

//             <i
//               className={`position-absolute top-0 end-0 me-3 m-2 fs-5 px-2 py-1 shadow rounded-circle ${wishlistItems.includes(Number(finalId)) ? "bi bi-suit-heart-fill text-danger bg-white" : "bi bi-suit-heart text-white bg-dark bg-opacity-50"}`} // ✅ finalId
//               style={{ cursor: "pointer", zIndex: 2 }}
//               onClick={(e) => { e.stopPropagation(); toggleWishlist(Number(finalId)); }} // ✅ finalId
//             ></i>

//           </div>

//           {/* DETAILS */}
//           <div className="col-12 col-lg-7 col-md-6 p-5 pt-md-0 pt-sm-2">
//             <p className="text-primary fw-bold">{BannerUser.pdetails_sheading}</p>
//             <h2 className="fw-bold">{BannerUser.Product_name}</h2>

//             <div className="d-flex align-items-center justify-content-between flex-wrap">
//               <p className="text-muted mb-0">{renderStars(BannerUser.rating)} 3 &nbsp;&nbsp; SKU:<b>S5T6U7V8</b></p>
//               <button
//                 className="btn btn-light border rounded-circle ms-2" style={{ width: "40px", height: "40px" }}
//                 onClick={() => {
//                   const url  = `${window.location.origin}/DetailsSection3/${BannerUser.prod_id}`;
//                   const text = `${BannerUser.Product_name} ${url}`;
//                   if (navigator.share) { navigator.share({ title: BannerUser.Product_name, text: BannerUser.Product_name, url }); }
//                   else { navigator.clipboard.writeText(text); alert("Link copied!"); }
//                 }}
//               ><i className="bi bi-share"></i></button>
//             </div>
//             <hr />

//             <div className="d-flex align-items-center mb-3 justify-content-between">
//               <div className="d-flex align-items-center">
//                 <h1 className="text-success me-2 fw-bold mb-0">₹{Number(BannerUser.current_price || 0) * qty}</h1>
//                 <h3 className="text-decoration-line-through text-muted mb-0">₹{BannerUser.old_price}</h3>
//                 <div className="qty-desktop">{QtyBlock}</div>
//               </div>
//               {BannerUser.stock_status && <span className="badge bg-light text-success">{BannerUser.stock_status}</span>}
//             </div>

//             <div className="product-meta mb-3">
//               <div className="meta-item"><span className="meta-label">Weight:</span><span className="meta-value">{BannerUser.weight} kg</span></div>
//               <div className="meta-item"><span className="meta-label">Dimension:</span><span className="meta-value">{BannerUser.dimension} cm</span></div>
//             </div>

//             {/* SIZE SELECTION */}
//             {hasSizes && (
//               <div className="mb-3">
//                 <p className="fw-bold">Select Size</p>
//                 <div className="d-flex gap-2 flex-wrap">
//                   {sizes.map((size) => (
//                     <button
//                       key={size.size_id}
//                       className={`btn ${selectedSize?.size_id === size.size_id ? "btn-dark" : "btn-outline-dark"}`}
//                       onClick={() => {
//                         setSelectedSize(size);
//                         setBannerUser(prev => ({ ...prev, current_price: size.variant_price, old_price: size.variant_old_price }));
//                       }}
//                     >{size.size}</button>
//                   ))}
//                 </div>
//               </div>
//             )}

//                         {/* ★★★ QUANTITY SET SELECTION — NEW ★★★ */}
//             {priceType === "quantity_set" && quantityVariants.length > 0 && (
//               <div className="mb-3">
//                 <p className="fw-bold">Select Quantity</p>
//                 <div className="d-flex gap-2 flex-wrap">
//                   {quantityVariants.map((qv, index) => (
//                     <button
//                       key={index}
//                       className={`btn ${
//                         selectedQtyIndex === index
//                           ? "btn-dark"
//                           : "btn-outline-dark"
//                       }`}
//                       style={{ minWidth: "130px" }}
//                       onClick={() => {
//                         setSelectedQtyIndex(index);
//                         setBannerUser(prev => ({
//                           ...prev,
//                           current_price: qv.current_price,
//                           old_price: qv.old_price || "",
//                         }));
//                       }}
//                     >
//                       <div className="text-center">
//                         <div className="fw-semibold">{qv.label || `${qv.quantity} Pc`}</div>
//                         <div className="small text-success">₹{qv.current_price}</div>
//                         {qv.old_price && (
//                           <div className="small text-muted text-decoration-line-through">₹{qv.old_price}</div>
//                         )}
//                       </div>
//                     </button>
//                   ))}
//                 </div>
//               </div>
//             )}

//             <div className="product-description mb-4" dangerouslySetInnerHTML={{ __html: BannerUser.discription || "" }} />

//             <div className="d-flex align-items-center">
//               <div className="qty-mobile mt-3">{QtyBlock}</div>
//             </div>

//             <div className="row g-2 mt-3 justify-content-md-start d-none d-lg-flex">
//               <div className="col-6 col-md-auto">
//                 <button className="w-100 border-0 rounded-3 bg-col text-light py-3 py-md-2 px-3 px-md-5 text-nowrap" onClick={handleAddToCart} disabled={added} style={{ fontSize: "15px", fontWeight: "500" }}>
//                   {added ? <>Added <span className="ms-1"><i className="bi bi-check2"></i></span></> : <>Add to cart <span className="ms-1"><i className="bi bi-bag"></i></span></>}
//                 </button>
//               </div>
//               <div className="col-6 col-md-auto">
//                 <button className="w-100 border-0 rounded-3 bg-col text-light py-3 py-md-2 px-3 px-md-5 text-nowrap" onClick={handleBuyNow} style={{ fontSize: "15px", fontWeight: "500" }}>
//                   Buy Now
//                 </button>
//               </div>
//             </div>

//             {/* STICKY MOBILE BUTTONS */}
// <div className="sticky-cart-bar d-lg-none">
//   <button
//     className="sticky-cart-btn"
//     onClick={handleAddToCart}
//     disabled={added}
//   >
//     {added ? <>Added <i className="bi bi-check2 ms-1"></i></> : <>Add to Cart <i className="bi bi-bag ms-1"></i></>}
//   </button>
//   <button
//     className="sticky-buy-btn"
//     onClick={handleBuyNow}
//   >
//     Buy Now
//   </button>
// </div>
// {/* Ui part of 3 design start */}
// <div className="pt-4">
//   <div className="delivery-features-strip">

//     <div className="feature-item">
//       <div className="feature-icon-wrap">
//         <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
//           <path d="M20 7H4C2.9 7 2 7.9 2 9v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2z" fill="#24aeb1" opacity="0.2"/>
//           <path d="M20 7H4C2.9 7 2 7.9 2 9v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2z" stroke="#24aeb1" strokeWidth="1.5" fill="none"/>
//           <path d="M16 3H8L6 7h12l-2-4z" stroke="#24aeb1" strokeWidth="1.5" fill="none"/>
//           <circle cx="7" cy="19" r="2" fill="#24aeb1"/>
//           <circle cx="17" cy="19" r="2" fill="#24aeb1"/>
//           <path d="M8 11l-2 2 2 2" stroke="#24aeb1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//           <path d="M6 13h4" stroke="#24aeb1" strokeWidth="1.5" strokeLinecap="round"/>
//         </svg>
//       </div>
//       <div className="feature-text">
//         <span className="feature-title">7 Days</span>
//         <span className="feature-title">Easy Return</span>
//       </div>
//     </div>

//     <div className="feature-divider" />

//     <div className="feature-item">
//       <div className="feature-icon-wrap">
//         <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
//           <rect x="2" y="6" width="20" height="13" rx="2" fill="#24aeb1" opacity="0.15" stroke="#24aeb1" strokeWidth="1.5"/>
//           <path d="M2 10h20" stroke="#24aeb1" strokeWidth="1.5"/>
//           <circle cx="12" cy="15" r="2.5" fill="#24aeb1" opacity="0.5" stroke="#24aeb1" strokeWidth="1"/>
//           <path d="M12 13.5v3M10.5 15h3" stroke="#24aeb1" strokeWidth="1" strokeLinecap="round"/>
//         </svg>
//       </div>
//       <div className="feature-text">
//         <span className="feature-title">Cash on</span>
//         <span className="feature-title">Delivery</span>
//       </div>
//     </div>

//     <div className="feature-divider" />

//     <div className="feature-item">
//       <div className="feature-icon-wrap">
//         <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
//           <path d="M12 3l1.5 4.5H18l-3.75 2.7 1.5 4.5L12 12l-3.75 2.7 1.5-4.5L6 7.5h4.5L12 3z" fill="#24aeb1" opacity="0.2" stroke="#24aeb1" strokeWidth="1.5" strokeLinejoin="round"/>
//           <path d="M8 18h8M9.5 21h5" stroke="#24aeb1" strokeWidth="1.5" strokeLinecap="round"/>
//         </svg>
//       </div>
//       <div className="feature-text">
//         <span className="feature-title">Lowest</span>
//         <span className="feature-title">Price</span>
//       </div>
//     </div>

//   </div>
// </div>

// <div className="border1 rounded p-3 mt-4 bg-light1 bg-reviews">

//   {/* DESKTOP ONLY */}
//   <div className="d-none d-lg-flex align-items-center justify-content-between mb-1">
//     <h5>Ratings and Reviews</h5>
//     <div className="d-flex gap-2">
//       <button
//         className="bg_footer border-0 rounded-2 text-white p-md-2 mobilereview"
//         onClick={() => navigate(`/reviews/${finalId}`)} // ✅ finalId
//       >
//         View Reviews →
//       </button>
//       <button
//         className="bg_footer border-0 rounded-2 text-white p-md-2"
//         onClick={() => setShowReviewModal(true)}
//       >
//         Add Review <i className="bi bi-plus ps-2"></i>
//       </button>
//     </div>
//   </div>

//   {/* DESKTOP rating row */}
//   <div className="d-none d-lg-flex align-items-center gap-2">
//     <span className="badge bg-success fs-6">{BannerUser.rating || 3.6} ★</span>
//     <span className="text-muted small">256 Ratings</span>
//   </div>

//   {/* MOBILE ONLY */}
//   <div className="d-lg-none">
//     <h5 className="mb-2">Ratings and Reviews</h5>
//     <div className="d-flex align-items-center gap-2 mb-2">
//       <span className="badge bg-success fs-6">{BannerUser.rating || 3.6} ★</span>
//       <span className="text-muted small">256 Ratings</span>
//     </div>

//     {/* ✅ IMAGES PEHLE - buttons se upar */}
//     {reviews.length > 0 && reviews[0]?.review_images?.length > 0 && (
//       <div className="d-flex gap-2 mb-3 overflow-auto">
//         {reviews[0].review_images.slice(0, 3).map((img, i) => (
//           <img key={i} src={`${BASE_URL}/${img}`}
//             style={{ width: "70px", height: "55px", objectFit: "cover", borderRadius: "6px" }}
//             alt={`review-img-${i}`}
//           />
//         ))}
//       </div>
//     )}

//     {/* ✅ BUTTONS BAAD MEIN - images ke neeche */}
//     <div className="d-flex gap-2">
//       <button
//         className="bg_footer border-0 rounded-2 text-white review-action-btn"
//         onClick={() => navigate(`/reviews/${finalId}`)} // ✅ finalId
//       >
//         View Reviews →
//       </button>
//       <button
//         className="bg_footer border-0 rounded-2 text-white review-action-btn"
//         onClick={() => setShowReviewModal(true)}
//       >
//         Add Review <i className="bi bi-plus ps-1"></i>
//       </button>
//     </div>
//   </div>

//   {/* DESKTOP images */}
//   {reviews.length > 0 && reviews[0]?.review_images?.length > 0 && (
//     <div className="d-none d-lg-flex gap-2 mt-2 overflow-auto">
//       {reviews[0].review_images.slice(0, 3).map((img, i) => (
//         <img key={i} src={`${BASE_URL}/${img}`}
//           style={{ width: "70px", height: "55px", objectFit: "cover", borderRadius: "6px" }}
//           alt={`review-img-${i}`}
//         />
//       ))}
//     </div>
//   )}

// </div>

//           </div>
//         </div>
//       </div>

//       <div className="container-fluid px-5">
//         <h3 className="text-decoration-underline">Description</h3>
//         <hr />
//         <div className="product-description mb-5" dangerouslySetInnerHTML={{ __html: BannerUser.large_description || BannerUser.discription }} />
//       </div>

//       {relatedProducts.length > 0 && (
//         <CategorySection title="Similar Products" products={relatedProducts} categoryName={BannerUser.category_id} />
//       )}

//       {/* REVIEW MODAL */}
//       {showReviewModal && (
//         <div className="review-modal-overlay">
//           <div className="review-modal">
//             <h4>Add Review</h4>
//             <select name="rating" onChange={handleReviewChange} className="form-control mb-2">
//               <option value="">Select Rating</option>
//               <option value="5">5 ⭐</option>
//               <option value="4">4 ⭐</option>
//               <option value="3">3 ⭐</option>
//               <option value="2">2 ⭐</option>
//               <option value="1">1 ⭐</option>
//             </select>
//             <input type="text" name="review_title" placeholder="Review Title" className="form-control mb-2" onChange={handleReviewChange} />
//             <textarea name="review_text" placeholder="Write review" className="form-control mb-2" onChange={handleReviewChange} />
//             <input type="file" multiple className="form-control mb-2" onChange={handleReviewImages} />
//             <div className="d-flex justify-content-end gap-2">
//               <button className="btn btn-secondary" onClick={() => setShowReviewModal(false)}>Cancel</button>
//               <button className="btn btn-primary"   onClick={handleSubmitReview}>Submit</button>
//             </div>
//           </div>
//         </div>
//       )}

//       <DetailsSection2dynamic />
//       <FooterNew />
//     </>
//   );
// }

// export default DetailsSection3;




// 27July code upar ka code hi hai bas isme na client out of stcok ka add akrne ko bola to thoda chnge kiya hai isliye
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate} from "react-router-dom";
import Layout from "../../Layout/Layout";
// import Footer from "../../Layout/Footer";
import DetailsSection2dynamic from "./DetailsSection2dynamic";
import { useCart } from "../../../Context/CartContext";
import { useWishlist } from "../../../Context/WishlistContext";
// import { AddToCart } from "../Products/AddtoCart";
import FooterNew from "../../Layout/FooterNew";
import CategorySection from "../HomePage/CategorySection";
import SEO from "../../SEO";

const BASE_URL = "https://ecom.cyberathon.com";

const isProductOutOfStock = (product) => {
  if (!product.stock_status) return false;
  const status = String(product.stock_status).toLowerCase().trim();
  return (
    status === "out of stock" ||
    status === "out_of_stock" ||
    status === "outofstock" ||
    status === "0"
  );
};

const getCartToken = () => {
  let token = localStorage.getItem("cart_token");
  if (!token) {
    token = crypto.randomUUID();
    localStorage.setItem("cart_token", token);
  }
  return token;
};

function DetailsSection3() {
  const normalizeId = (value) => {
    if (!value) return null;
    return value.includes("-") ? value.split("-").pop() : value;
  };

  const { prod_id } = useParams();
  const finalId = normalizeId(prod_id);
  const navigate = useNavigate();

  const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();
  const { wishlistItems, toggleWishlist } = useWishlist();

  const [added, setAdded] = useState(false);
  const [qty, setQty] = useState(1);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [sizes, setSizes] = useState([]);

  // 14july2026 3pecie, 5 pecie ke liye add hona client ne bola
  // ★ NEW: Quantity Set states
  const [priceType, setPriceType] = useState("simple");
  const [quantityVariants, setQuantityVariants] = useState([]);
  const [selectedQtyIndex, setSelectedQtyIndex] = useState(0);

  const [notifyRequested, setNotifyRequested] = useState(false);
  const [notifyLoading, setNotifyLoading] = useState(false);

  const hasSizes = sizes?.length > 0;

  const [BannerUser, setBannerUser] = useState({
    Product_image: [],
    Product_name: "",
    category_id: "",
    discription: "",
    old_price: "",
    current_price: "",
    discount: "",
    rating: "",
    pdetails_sheading: "",
    large_description: "",
    stock_status: "",
    prod_id: "",
    product_type: "product",
    weight: 0,
    // ★ NEW
    price_type: "simple",
    quantity_variants: [],
  });

  const [relatedProducts, setRelatedProducts] = useState([]);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewForm, setReviewForm] = useState({
    rating: "",
    review_title: "",
    review_text: "",
    review_images: [],
  });
  const [reviews, setReviews] = useState([]);
  const [seoData, setSeoData] = useState({});

  useEffect(() => {
    const fetchSeo = async () => {
      try {
        const response = await axios.post(
          `${BASE_URL}/index.php/Api/get_seo_by_page`,
          { page_name: "product_detail" },
        );
        if (response.data.status === "true") {
          const data = response.data.data;
          setSeoData({
            title: data.meta_title,
            description: data.meta_description,
            keywords: data.meta_keywords,
            canonical: data.canonical_url,
          });
        }
      } catch (error) {
        console.error("SEO fetch error:", error);
      }
    };
    fetchSeo();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  /* CHECK IF PRODUCT ALREADY IN CART */
  // useEffect(() => {
  //   const checkIfAdded = async () => {
  //     const userId = sessionStorage.getItem("userId");
  //     const cartToken = !userId ? localStorage.getItem("cart_token") : null;
  //     if (!userId && !cartToken) return;
  //     try {
  //       const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
  //         user_id: userId ? userId : null,
  //         cart_token: cartToken ? cartToken : null,
  //       });
  //       if (res.data.status) {
  //         const prodIds = res.data.cart_items.map((i) => String(i.prod_id));
  //         if (prodIds.includes(String(finalId))) setAdded(true); // ✅ finalId
  //       }
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };
  //   checkIfAdded();
  // }, [finalId]); 


    /* CHECK IF PRODUCT ALREADY IN CART */
  useEffect(() => {
    const checkIfAdded = async () => {
      const userId = sessionStorage.getItem("userId");
      const cartToken = !userId ? localStorage.getItem("cart_token") : null;
      if (!userId && !cartToken) return;
      try {
        const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
          user_id: userId ? userId : null,
          cart_token: cartToken ? cartToken : null,
        });
        if (res.data.status) {
          // ✅ FIX: Sirf SIMPLE products ke liye "Added" dikhao
          // Size ya Pack wale products ke liye MAT dikhao — user ko variant select karna hai
          const found = res.data.cart_items.find(
            (i) => String(i.prod_id) === String(finalId)
          );
          if (found) {
            const hasSize = found.size_id && String(found.size_id) !== "0" && String(found.size_id) !== "null";
            const hasQtySet = found.selected_quantity_set && found.selected_quantity_set !== "null" && found.selected_quantity_set !== null;
            if (!hasSize && !hasQtySet) {
              setAdded(true);
            }
          }
        }
      } catch (err) {
        console.error(err);
      }
    };
    checkIfAdded();
  }, [finalId]);



  /* FETCH PRODUCT --> iss code size option hide ho gaya tha*/
  //   useEffect(() => {
  //   const fetchProduct = async () => {
  //     try {
  //       let response;

  //       // ✅ NORMAL ID
  //       if (!prod_id.includes("-")) {
  //         response = await axios.post(
  //           `${BASE_URL}/index.php/Api/get_by_id_create_product`,
  //           { prod_id: finalId }
  //         );
  //       }

  //       // ✅ SLUG CASE
  //       else {
  //         const slug = prod_id
  //           .toLowerCase()
  //           .split("-")
  //           .slice(0, -1)
  //           .join(" ");

  //         const res = await axios.get(
  //           `${BASE_URL}/index.php/Api/list_get_product`
  //         );

  //         const products = res.data.products || [];

  //         const matched = products.find((p) => {
  //           const name = p.Product_name.toLowerCase();
  //           return slug.split(" ").every(word => name.includes(word));
  //         });

  //         if (!matched) {
  //           console.log("No match found:", slug);
  //           navigate("/products");
  //           return;
  //         }

  //         response = await axios.post(
  //           `${BASE_URL}/index.php/Api/get_by_id_create_product`,
  //           { prod_id: matched.prod_id }
  //         );
  //       }

  //       if (response?.data?.products?.length > 0) {
  //         setBannerUser(response.data.products[0]);
  //       }

  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //   fetchProduct();
  // }, [prod_id]);

  /* FETCH PRODUCT --> size option hide ho gaya tha wo laya iss code se*/
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        let productData = [];

        // ✅ NORMAL ID
        if (!prod_id.includes("-")) {
          const response = await axios.post(
            `${BASE_URL}/index.php/Api/get_by_id_create_product`,
            { prod_id: finalId },
          );
          productData = response.data.products || [];
        }

        // ✅ SLUG CASE
        else {
          const slug = prod_id.toLowerCase().split("-").slice(0, -1).join(" ");

          const res = await axios.get(
            `${BASE_URL}/index.php/Api/list_get_product`,
          );

          const products = res.data.products || [];

          const matched = products.find((p) => {
            const name = p.Product_name.toLowerCase();
            return slug.split(" ").every((word) => name.includes(word));
          });

          if (!matched) {
            console.log("No match found:", slug);
            navigate("/products");
            return;
          }

          const response = await axios.post(
            `${BASE_URL}/index.php/Api/get_by_id_create_product`,
            { prod_id: matched.prod_id },
          );
          productData = response.data.products || [];
        }

        // nikita code 3pecie 5 pecie logic add karne ke phele wala code
        // ✅ SIZE LOGIC (purane code se restore kiya — yahi missing tha)
        // if (productData.length > 0) {
        //   const firstProduct = productData[0];
        //   const validSizes = productData.filter(
        //     p => p.size !== null && p.size !== "" && p.size !== "0"
        //   );

        //   setBannerUser({
        //     ...firstProduct,
        //     current_price: validSizes.length > 0 ? validSizes[0].variant_price : firstProduct.current_price,
        //     old_price:     validSizes.length > 0 ? validSizes[0].variant_old_price : firstProduct.old_price,
        //   });

        //   if (validSizes.length > 0) {
        //     setSizes(validSizes);
        //     setSelectedSize(null);
        //   } else {
        //     setSizes([]);
        //     setSelectedSize(null);
        //   }
        // }

        // 14july2026 3pecie 5 pecie add karne ko bola tha client ne
        if (productData.length > 0) {
          const firstProduct = productData[0];

          // ★ STEP 1: Check price_type
          const pType = firstProduct.price_type || "simple";
          setPriceType(pType);

          // ★ STEP 2: Parse quantity_variants if string
          let qv = firstProduct.quantity_variants || [];
          if (typeof qv === "string") {
            try {
              qv = JSON.parse(qv);
            } catch {
              qv = [];
            }
          }
          if (!Array.isArray(qv)) qv = [];

          // ★ STEP 3: SIZE VARIANT logic (purana — unchanged)
          const validSizes = productData.filter(
            (p) => p.size !== null && p.size !== "" && p.size !== "0",
          );

          // ★ STEP 4: Set BannerUser based on price type
          if (pType === "quantity_set" && qv.length > 0) {
            // Quantity set — first variant ki price as default
            setBannerUser({
              ...firstProduct,
              current_price: qv[0].current_price,
              old_price: qv[0].old_price || "",
              quantity_variants: qv,
            });
            setQuantityVariants(qv);
            setSelectedQtyIndex(0);
            setSizes([]);
            setSelectedSize(null);
          } else if (validSizes.length > 0) {
            // Size variant — purana flow
            setBannerUser({
              ...firstProduct,
              current_price: validSizes[0].variant_price,
              old_price: validSizes[0].variant_old_price,
            });
            setSizes(validSizes);
            setSelectedSize(null);
            setQuantityVariants([]);
            setSelectedQtyIndex(0);
          } else {
            // Simple price — purana flow
            setBannerUser({ ...firstProduct });
            setSizes([]);
            setSelectedSize(null);
            setQuantityVariants([]);
            setSelectedQtyIndex(0);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchProduct();
  }, [prod_id]);

  /* FETCH REVIEWS */
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await axios.post(
          `${BASE_URL}/index.php/Api/list_product_reviews`,
          { prod_id: finalId },
        ); // ✅ finalId
        if (res.data.status === "true") setReviews(res.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchReviews();
  }, [finalId]); // ✅ finalId

  /* SET FIRST IMAGE */
  useEffect(() => {
    if (BannerUser.Product_image?.length > 0)
      setSelectedImage(BannerUser.Product_image[0]);
  }, [BannerUser.Product_image]);

  /* FETCH SIMILAR PRODUCTS */
  useEffect(() => {
    if (!BannerUser.category_id) return;
    const fetchRelatedProducts = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/index.php/Api/list_get_product`,
        );
        if (res.data.products) {
          const filtered = res.data.products.filter(
            (item) =>
              String(item.category_id) === String(BannerUser.category_id) &&
              String(item.prod_id) !== String(finalId), // ✅ finalId
          );
          setRelatedProducts(filtered);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchRelatedProducts();
  }, [BannerUser.category_id, finalId]); // ✅ finalId

  /* QTY CONTROLS */
  const increaseQty = () => setQty((prev) => prev + 1);
  const decreaseQty = () => {
    if (qty > 1) setQty((prev) => prev - 1);
  };

  const QtyBlock = (
    <div className="qty-wrapper">
      <button
        type="button"
        className="qty-btn-action"
        onClick={decreaseQty}
        disabled={qty <= 1}
      >
        −
      </button>
      <input
        type="text"
        value={qty}
        inputMode="numeric"
        pattern="[0-9]*"
        className="qty-input"
        onChange={(e) => {
          const val = e.target.value.replace(/\D/g, "");
          if (val === "") setQty("");
          else setQty(Math.max(1, Number(val)));
        }}
        onBlur={() => {
          if (!qty || qty < 1) setQty(1);
        }}
      />
      <button type="button" className="qty-btn-action" onClick={increaseQty}>
        +
      </button>
    </div>
  );

  /* STARS */
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 !== 0;
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < fullStars; i++)
      stars.push(
        <i key={"f" + i} className="fa-solid fa-star text-warning"></i>,
      );
    if (hasHalf)
      stars.push(
        <i
          key="half"
          className="fa-solid fa-star-half-stroke text-warning"
        ></i>,
      );
    for (let i = 0; i < emptyStars; i++)
      stars.push(
        <i key={"e" + i} className="fa-regular fa-star text-warning"></i>,
      );
    return stars;
  };

  /* BUY NOW */
  const handleBuyNow = () => {
    const userId = sessionStorage.getItem("userId");

    // discount nhi calculate ho raha tha nikita code
    // const buyNowProduct = {
    //   prod_id: BannerUser.prod_id,
    //   Product_name: BannerUser.Product_name,
    //   current_price: selectedSize?.variant_price || BannerUser.current_price,
    //   qty: qty,
    //   Product_image: BannerUser.Product_image?.[0],
    //   product_type: BannerUser.product_type || "product",
    //   weight: parseFloat(BannerUser.weight) || 0,
    // };

    // 02-07-2026 client ke discout add karne hai bolne ke bad wala code
    //     const buyNowProduct = {
    //   prod_id: BannerUser.prod_id,
    //   Product_name: BannerUser.Product_name,
    //   current_price: selectedSize?.variant_price || BannerUser.current_price,
    //   old_price: selectedSize?.variant_old_price || BannerUser.old_price,
    //   discount: Number(BannerUser.discount) || 0,
    //   qty: qty,
    //   Product_image: BannerUser.Product_image?.[0],
    //   product_type: BannerUser.product_type || "product",
    //   weight: parseFloat(BannerUser.weight) || 0,
    // };

    //     if (selectedSize?.size_id) {
    //       buyNowProduct.size = selectedSize.size;
    //       buyNowProduct.size_id = selectedSize.size_id;
    //     }

    // 14-july-2026 client ke discout add karne hai bolne ke bad wala code
    // ★ Selected price: size ya quantity set ya simple
    const selectedPrice =
      selectedSize?.variant_price ||
      (priceType === "quantity_set" &&
        quantityVariants[selectedQtyIndex]?.current_price) ||
      BannerUser.current_price;

    const selectedOldPrice =
      selectedSize?.variant_old_price ||
      (priceType === "quantity_set" &&
        quantityVariants[selectedQtyIndex]?.old_price) ||
      BannerUser.old_price;

    const buyNowProduct = {
      prod_id: BannerUser.prod_id,
      Product_name: BannerUser.Product_name,
      current_price: selectedPrice,
      old_price: selectedOldPrice,
      discount: Number(BannerUser.discount) || 0,
      qty: qty,
      Product_image: BannerUser.Product_image?.[0],
      product_type: BannerUser.product_type || "product",
      weight: parseFloat(BannerUser.weight) || 0,
      // ★ NEW: Quantity set info pass karo
      price_type: priceType,
      selected_quantity_set:
        priceType === "quantity_set"
          ? quantityVariants[selectedQtyIndex]
          : null,
    };

    if (selectedSize?.size_id) {
      buyNowProduct.size = selectedSize.size;
      buyNowProduct.size_id = selectedSize.size_id;
    }

    if (userId) {
      navigate("/Bill", { state: { buyNow: true, product: buyNowProduct } });
    } else {
      setRedirectAfterLogin("/Bill");
      sessionStorage.setItem("buyNowProduct", JSON.stringify(buyNowProduct));
      setShowLogin(true);
    }
  };

  /* ADD TO CART */
  const handleAddToCart = async () => {
    const userId = sessionStorage.getItem("userId");
    const cartToken = !userId ? getCartToken() : null;

    try {
      const res = await axios.post(`${BASE_URL}/index.php/Api/list_cart`, {
        user_id: userId ? userId : null,
        cart_token: cartToken ? cartToken : null,
      });

      // let cartItem = null;
      // if (res.data.status) {
      //   cartItem = res.data.cart_items.find(
      //     (i) => String(i.prod_id) === String(finalId),
      //   ); // ✅ finalId
      // }

      let cartItem = null;
      if (res.data.status) {
        cartItem = res.data.cart_items.find((i) => {
          if (String(i.prod_id) !== String(finalId)) return false;

          // ✅ FIX: Size selected hai to size_id match karo
          if (selectedSize?.size_id) {
            return String(i.size_id) === String(selectedSize.size_id);
          }

          // ✅ FIX: Quantity set selected hai to match karo
          // if (priceType === "quantity_set" && quantityVariants[selectedQtyIndex]) {
          //   const currentSet = quantityVariants[selectedQtyIndex];
          //   const cartSet = i.selected_quantity_set;
          //   if (!cartSet) return false;
          //   try {
          //     const parsed = typeof cartSet === "string" ? JSON.parse(cartSet) : cartSet;
          //     return String(parsed.label || parsed.quantity) === String(currentSet.label || currentSet.quantity);
          //   } catch {
          //     return false;
          //   }
          // }


                    // ✅ FIX: Quantity set selected hai to match karo — price + label dono se match
          // if (priceType === "quantity_set" && quantityVariants[selectedQtyIndex]) {
          //   const currentSet = quantityVariants[selectedQtyIndex];
          //   const cartSet = i.selected_quantity_set;
          //   if (!cartSet) return false;
          //   try {
          //     const parsed = typeof cartSet === "string" ? JSON.parse(cartSet) : cartSet;
          //     // Price bhi match karo — extra safety
          //     const priceMatch = Number(i.current_price) === Number(currentSet.current_price);
          //     const labelMatch = String(parsed.label || "") === String(currentSet.label || "");
          //     const qtyMatch = Number(parsed.quantity) === Number(currentSet.quantity);
          //     return priceMatch && (labelMatch || qtyMatch);
          //   } catch {
          //     return false;
          //   }
          // }


                    // ✅ FIX: Quantity set — SIRF LABEL se match karo (unique hai)
          // priceMatch MAT use karo kyunki cart me hamesha base price (200) aata hai
          // qtyMatch MAT use karo kyunki multiple pins me same quantity (5, 10) ho sakti hai
          if (priceType === "quantity_set" && quantityVariants[selectedQtyIndex]) {
            const currentSet = quantityVariants[selectedQtyIndex];
            const cartSet = i.selected_quantity_set;
            if (!cartSet) return false;
            try {
              const parsed = typeof cartSet === "string" ? JSON.parse(cartSet) : cartSet;
              const labelMatch = String(parsed.label || "") === String(currentSet.label || "");
              return labelMatch;
            } catch {
              return false;
            }
          }

          // Simple product — sirf prod_id match karo
          return true;
        });
      }

      // Nikita code 3pecie 5 pecie logic add karne ke phele wala code
      // const payload = {
      //   user_id: userId ? userId : null,
      //   cart_token: cartToken ? cartToken : null,
      //   prod_id: BannerUser.prod_id,
      //   quantity: qty,
      //   current_price: selectedSize?.variant_price || BannerUser.current_price,
      //   old_price: selectedSize?.variant_old_price || BannerUser.old_price,
      // };

      // if (selectedSize?.size_id) {
      //   payload.size = selectedSize.size;
      //   payload.size_id = selectedSize.size_id;
      // }

      // ★ Selected price
      const cartSelectedPrice =
        selectedSize?.variant_price ||
        (priceType === "quantity_set" &&
          quantityVariants[selectedQtyIndex]?.current_price) ||
        BannerUser.current_price;

      const cartSelectedOldPrice =
        selectedSize?.variant_old_price ||
        (priceType === "quantity_set" &&
          quantityVariants[selectedQtyIndex]?.old_price) ||
        BannerUser.old_price;

      const payload = {
        user_id: userId ? userId : null,
        cart_token: cartToken ? cartToken : null,
        prod_id: BannerUser.prod_id,
        quantity: qty,
        current_price: cartSelectedPrice,
        old_price: cartSelectedOldPrice,
      };

      if (selectedSize?.size_id) {
        payload.size = selectedSize.size;
        payload.size_id = selectedSize.size_id;
      }

      // ★ Quantity set info
      if (priceType === "quantity_set" && quantityVariants[selectedQtyIndex]) {
        payload.price_type = "quantity_set";
        payload.selected_quantity_set = quantityVariants[selectedQtyIndex];
      }

      if (cartItem) {
        await axios.post(`${BASE_URL}/index.php/Api/update_cart`, {
          cart_id: cartItem.cart_id,
          quantity: qty,
          user_id: userId ? userId : null,
          cart_token: cartToken ? cartToken : null,
        });
      } else {
        await axios.post(`${BASE_URL}/index.php/Api/insert_cart`, payload);
        setCartCount((prev) => prev + 1);
      }
      setAdded(true);
    } catch (error) {
      console.error(error);
    }
  };

  /* REVIEW HANDLERS */
  const handleReviewChange = (e) => {
    const { name, value } = e.target;
    setReviewForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleReviewImages = (e) => {
    const filesArray = Array.from(e.target.files);
    setReviewForm((prev) => ({ ...prev, review_images: filesArray }));
  };

  const handleSubmitReview = async () => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      alert("Please login first");
      return;
    }
    if (!reviewForm.rating) {
      alert("Please select a rating");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("prod_id", finalId); // ✅ finalId
      formData.append("user_id", userId);
      formData.append("rating", reviewForm.rating);
      formData.append("review_title", reviewForm.review_title || "");
      formData.append("review_text", reviewForm.review_text || "");
      if (reviewForm.review_images?.length > 0) {
        reviewForm.review_images.forEach((img) =>
          formData.append("review_images[]", img, img.name),
        );
      }
      const response = await axios.post(
        `${BASE_URL}/index.php/Api/add_product_reviews`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      if (response.data.status === "true") {
        alert("Review Added Successfully!");
        const res = await axios.post(
          `${BASE_URL}/index.php/Api/list_product_reviews`,
          { prod_id: finalId },
        ); // ✅ finalId
        if (res.data.status === "true") setReviews(res.data.data);
        setShowReviewModal(false);
        setReviewForm({
          rating: "",
          review_title: "",
          review_text: "",
          review_images: [],
        });
      } else {
        alert("Failed to add review. Try again.");
      }
    } catch (error) {
      console.error("Review submit error:", error);
      alert("Something went wrong!");
    }
  };

  const handleViewAll = () => {
    if (!BannerUser.category_name) return;
    navigate("/products", {
      state: { categoryKey: BannerUser.category_name.replaceAll(" ", "") },
    });
  };

  const handleNotifyMe = async () => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      setRedirectAfterLogin(window.location.pathname);
      setShowLogin(true);
      return;
    }
    setNotifyLoading(true);
    try {
      const res = await axios.post(
        `${BASE_URL}/index.php/Api/add_stock_notification`,
        {
          user_id: userId,
          prod_id: BannerUser.prod_id,
          message: "Notify me when this product is back in stock",
        },
      );
      if (res.data.status === "true" || res.data.status === true) {
        setNotifyRequested(true);
        alert("We will notify you when this product is back in stock.");
      } else {
        alert(res.data.message || "Failed to send notification");
      }
    } catch (err) {
      alert("Failed to send notification. Please try again.");
    } finally {
      setNotifyLoading(false);
    }
  };

  return (
    <>
      <SEO
  title={
    BannerUser.Product_name
      ? `${BannerUser.Product_name} | Shopeindia`
      : seoData.title ||
        "Shopeindia | Aesthetic Machines & Cupping Therapy Supplies"
  }
  description={
    BannerUser.pdetails_sheading ||
    (BannerUser.discription
      ? BannerUser.discription
          .replace(/<[^>]*>/g, " ")
          .replace(/\s+/g, " ")
          .trim()
          .slice(0, 155)
      : seoData.description ||
        "Buy professional aesthetic machines and cupping therapy tools at Shopeindia.")
  }
  keywords={
    seoData.keywords ||
    "cupping therapy tools, aesthetic machines, shopeindia"
  }
  canonical={`https://shopeindia.co.in/DetailsSection3/${BannerUser.prod_id || finalId}`}
/>

      <Layout />

      <div className="container-fluid pt-5 pb-2">
        <div className="row align-items-start">
          {/* IMAGES */}
          <div className="col-12 col-lg-5 col-md-6 position-relative">
            <div>
              <div className="product-image-wrapper">
                <div className="thumbnail-column">
                  {BannerUser.Product_image?.map((img, index) => (
                    <img
                      key={index}
                      src={`${BASE_URL}/${img}`}
                      className={`thumb-img ${selectedImage === img ? "active-thumb" : ""}`}
                      onClick={() => setSelectedImage(img)}
                      alt="thumb"
                    />
                  ))}
                </div>
                <div className="big-image-wrapper">
                  <img
                    src={`${BASE_URL}/${selectedImage}`}
                    alt="product"
                    className="img-fluid imgsize"
                  />
                </div>
              </div>
            </div>

            <i
              className={`position-absolute top-0 end-0 me-3 m-2 fs-5 px-2 py-1 shadow rounded-circle ${wishlistItems.includes(Number(finalId)) ? "bi bi-suit-heart-fill text-danger bg-white" : "bi bi-suit-heart text-white bg-dark bg-opacity-50"}`} // ✅ finalId
              style={{ cursor: "pointer", zIndex: 2 }}
              onClick={(e) => {
                e.stopPropagation();
                toggleWishlist(Number(finalId));
              }} // ✅ finalId
            ></i>
          </div>

          {/* DETAILS */}
          <div className="col-12 col-lg-7 col-md-6 p-5 pt-md-0 pt-sm-2">
            <p className="textdetailcolor fw-bold">
              {BannerUser.pdetails_sheading}
            </p>
            <h2 className="fw-bold">{BannerUser.Product_name}</h2>

            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <p className="text-muted mb-0">
                {renderStars(BannerUser.rating)} 3 &nbsp;&nbsp; SKU:
                <b>S5T6U7V8</b>
              </p>
              <button
                className="btn btn-light border rounded-circle ms-2"
                style={{ width: "40px", height: "40px" }}
                onClick={() => {
                  const url = `${window.location.origin}/DetailsSection3/${BannerUser.prod_id}`;
                  const text = `${BannerUser.Product_name} ${url}`;
                  if (navigator.share) {
                    navigator.share({
                      title: BannerUser.Product_name,
                      text: BannerUser.Product_name,
                      url,
                    });
                  } else {
                    navigator.clipboard.writeText(text);
                    alert("Link copied!");
                  }
                }}
              >
                <i className="bi bi-share"></i>
              </button>
            </div>
            <hr />

            <div className="d-flex align-items-center mb-3 justify-content-between">
              <div className="d-flex align-items-center">
                <h1 className="text-dark me-2 fw-bold mb-0">
                  ₹{Number(BannerUser.current_price || 0) * qty}
                </h1>
                <h3 className="text-decoration-line-through text-muted mb-0">
                  ₹{BannerUser.old_price}
                </h3>
                <div className="qty-desktop">{QtyBlock}</div>
              </div>
              {/* {BannerUser.stock_status && <span className="badge bg-light text-success">{BannerUser.stock_status}</span>} */}

              {BannerUser.stock_status && (
                <span
                  className={`badge ${isProductOutOfStock(BannerUser) ? "bg-danger text-white" : "bg-light text-success"}`}
                  style={{ fontSize: "0.9rem" }}
                >
                  {isProductOutOfStock(BannerUser) ? "⚡ " : ""}
                  {BannerUser.stock_status}
                </span>
              )}
            </div>

            <div className="product-meta mb-3">
              <div className="meta-item">
                <span className="meta-label">Weight:</span>
                <span className="meta-value">{BannerUser.weight} kg</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Dimension:</span>
                <span className="meta-value">{BannerUser.dimension} cm</span>
              </div>
            </div>

            {/* SIZE SELECTION */}
            {hasSizes && (
              <div className="mb-3">
                <p className="fw-bold">Select Size</p>
                <div className="d-flex gap-2 flex-wrap">
                  {sizes.map((size) => (
                    <button
                      key={size.size_id}
                      className={`btn ${selectedSize?.size_id === size.size_id ? "btn-dark" : "btn-outline-dark"}`}
                      onClick={() => {
                        setSelectedSize(size);
                        setAdded(false); // ✅ FIX: Size change pe button wapas "Add to Cart"
                        setBannerUser((prev) => ({
                          ...prev,
                          current_price: size.variant_price,
                          old_price: size.variant_old_price,
                        }));
                      }}
                    >
                      {size.size}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* ★★★ QUANTITY SET SELECTION — NEW ★★★ */}
            {priceType === "quantity_set" && quantityVariants.length > 0 && (
              <div className="mb-3">
                <p className="fw-bold">Select Quantity</p>
                <div className="d-flex gap-2 flex-wrap">
                  {quantityVariants.map((qv, index) => (
                    <button
                      key={index}
                      className={`btn ${
                        selectedQtyIndex === index
                          ? "btn-dark"
                          : "btn-outline-dark"
                      }`}
                      style={{ minWidth: "130px" }}
                      onClick={() => {
                        setSelectedQtyIndex(index);
                        setAdded(false); // ✅ FIX: Pack change pe button wapas "Add to Cart"
                        setBannerUser((prev) => ({
                          ...prev,
                          current_price: qv.current_price,
                          old_price: qv.old_price || "",
                        }));
                      }}
                    >
                      <div className="text-center">
                        <div className="fw-semibold">
                          {qv.label || `${qv.quantity} Pc`}
                        </div>
                        <div className="small text-success">
                          ₹{qv.current_price}
                        </div>
                        {qv.old_price && (
                          <div className="small text-muted text-decoration-line-through">
                            ₹{qv.old_price}
                          </div>
                        )}
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div
              className="product-description mb-4"
              dangerouslySetInnerHTML={{ __html: BannerUser.discription || "" }}
            />

            <div className="d-flex align-items-center">
              <div className="qty-mobile mt-3">{QtyBlock}</div>
            </div>

            {/* <div className="row g-2 mt-3 justify-content-md-start d-none d-lg-flex">
              <div className="col-6 col-md-auto">
                <button className="w-100 border-0 rounded-3 bg-col text-light py-3 py-md-2 px-3 px-md-5 text-nowrap" onClick={handleAddToCart} disabled={added} style={{ fontSize: "15px", fontWeight: "500" }}>
                  {added ? <>Added <span className="ms-1"><i className="bi bi-check2"></i></span></> : <>Add to cart <span className="ms-1"><i className="bi bi-bag"></i></span></>}
                </button>
              </div>
              <div className="col-6 col-md-auto">
                <button className="w-100 border-0 rounded-3 bg-col text-light py-3 py-md-2 px-3 px-md-5 text-nowrap" onClick={handleBuyNow} style={{ fontSize: "15px", fontWeight: "500" }}>
                  Buy Now
                </button>
              </div>
            </div> */}

            {!isProductOutOfStock(BannerUser) ? (
              <div className="row g-2 mt-3 justify-content-md-start d-none d-lg-flex">
                <div className="col-6 col-md-auto">
                  <button
                    className="w-100 border-0 rounded-3 bg-col text-light py-3 py-md-2 px-3 px-md-5 text-nowrap"
                    onClick={handleAddToCart}
                    disabled={added}
                    style={{ fontSize: "15px", fontWeight: "500" }}
                  >
                    {added ? (
                      <>
                        Added{" "}
                        <span className="ms-1">
                          <i className="bi bi-check2"></i>
                        </span>
                      </>
                    ) : (
                      <>
                        Add to cart{" "}
                        <span className="ms-1">
                          <i className="bi bi-bag"></i>
                        </span>
                      </>
                    )}
                  </button>
                </div>
                <div className="col-6 col-md-auto">
                  <button
                    className="w-100 border-0 rounded-3 bg-col text-light py-3 py-md-2 px-3 px-md-5 text-nowrap"
                    onClick={handleBuyNow}
                    style={{ fontSize: "15px", fontWeight: "500" }}
                  >
                    Buy Now
                  </button>
                </div>
              </div>
            ) : (
              <div className="row g-2 mt-3 justify-content-md-start d-none d-lg-flex">
                <div className="col-12 col-md-auto">
                  <button
                    className={`w-100 border-0 rounded-3 py-3 py-md-2 px-3 px-md-5 text-nowrap fw-semibold ${
                      notifyRequested
                        ? "bg-secondary text-white"
                        : "notify-me-btn"
                    }`}
                    onClick={handleNotifyMe}
                    disabled={notifyRequested || notifyLoading}
                    style={{
                      fontSize: "15px",
                      cursor: notifyRequested ? "default" : "pointer",
                    }}
                  >
                    {notifyLoading ? (
                      <>
                        Sending Request...{" "}
                        <i className="bi bi-arrow-repeat spin-icon ms-1"></i>
                      </>
                    ) : notifyRequested ? (
                      <>
                        Notification Sent{" "}
                        <i className="bi bi-bell-fill ms-1"></i>
                      </>
                    ) : (
                      <>
                        Notify Me <i className="bi bi-bell ms-1"></i>
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}

            {/* STICKY MOBILE BUTTONS */}
            {/* <div className="sticky-cart-bar d-lg-none">
  <button
    className="sticky-cart-btn"
    onClick={handleAddToCart}
    disabled={added}
  >
    {added ? <>Added <i className="bi bi-check2 ms-1"></i></> : <>Add to Cart <i className="bi bi-bag ms-1"></i></>}
  </button>
  <button
    className="sticky-buy-btn"
    onClick={handleBuyNow}
  >
    Buy Now
  </button>
</div> */}

            {!isProductOutOfStock(BannerUser) ? (
              <div className="sticky-cart-bar d-lg-none">
                <button
                  className="sticky-cart-btn"
                  onClick={handleAddToCart}
                  disabled={added}
                >
                  {added ? (
                    <>
                      Added <i className="bi bi-check2 ms-1"></i>
                    </>
                  ) : (
                    <>
                      Add to Cart <i className="bi bi-bag ms-1"></i>
                    </>
                  )}
                </button>
                <button className="sticky-buy-btn" onClick={handleBuyNow}>
                  Buy Now
                </button>
              </div>
            ) : (
              <div
                className="sticky-cart-bar d-lg-none"
                style={{ justifyContent: "center" }}
              >
                <button
                  className={`sticky-notify-btn ${notifyRequested ? "sticky-notify-sent" : ""}`}
                  onClick={handleNotifyMe}
                  disabled={notifyRequested || notifyLoading}
                >
                  {notifyLoading ? (
                    <>
                      Sending...{" "}
                      <i className="bi bi-arrow-repeat spin-icon ms-1"></i>
                    </>
                  ) : notifyRequested ? (
                    <>
                      Notification Sent <i className="bi bi-bell-fill ms-1"></i>
                    </>
                  ) : (
                    <>
                      Notify Me <i className="bi bi-bell ms-1"></i>
                    </>
                  )}
                </button>
              </div>
            )}

            {/* Ui part of 3 design start */}
            <div className="pt-4">
              <div className="delivery-features-strip">
                <div className="feature-item">
                  <div className="feature-icon-wrap">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M20 7H4C2.9 7 2 7.9 2 9v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2z"
                        fill="#24aeb1"
                        opacity="0.2"
                      />
                      <path
                        d="M20 7H4C2.9 7 2 7.9 2 9v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2z"
                        stroke="#24aeb1"
                        strokeWidth="1.5"
                        fill="none"
                      />
                      <path
                        d="M16 3H8L6 7h12l-2-4z"
                        stroke="#24aeb1"
                        strokeWidth="1.5"
                        fill="none"
                      />
                      <circle cx="7" cy="19" r="2" fill="#24aeb1" />
                      <circle cx="17" cy="19" r="2" fill="#24aeb1" />
                      <path
                        d="M8 11l-2 2 2 2"
                        stroke="#24aeb1"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M6 13h4"
                        stroke="#24aeb1"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="feature-text">
                    <span className="feature-title">7 Days</span>
                    <span className="feature-title">Easy Return</span>
                  </div>
                </div>

                <div className="feature-divider" />

                <div className="feature-item">
                  <div className="feature-icon-wrap">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="2"
                        y="6"
                        width="20"
                        height="13"
                        rx="2"
                        fill="#24aeb1"
                        opacity="0.15"
                        stroke="#24aeb1"
                        strokeWidth="1.5"
                      />
                      <path d="M2 10h20" stroke="#24aeb1" strokeWidth="1.5" />
                      <circle
                        cx="12"
                        cy="15"
                        r="2.5"
                        fill="#24aeb1"
                        opacity="0.5"
                        stroke="#24aeb1"
                        strokeWidth="1"
                      />
                      <path
                        d="M12 13.5v3M10.5 15h3"
                        stroke="#24aeb1"
                        strokeWidth="1"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="feature-text">
                    <span className="feature-title">Cash on</span>
                    <span className="feature-title">Delivery</span>
                  </div>
                </div>

                <div className="feature-divider" />

                <div className="feature-item">
                  <div className="feature-icon-wrap">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 3l1.5 4.5H18l-3.75 2.7 1.5 4.5L12 12l-3.75 2.7 1.5-4.5L6 7.5h4.5L12 3z"
                        fill="#24aeb1"
                        opacity="0.2"
                        stroke="#24aeb1"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 18h8M9.5 21h5"
                        stroke="#24aeb1"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="feature-text">
                    <span className="feature-title">Lowest</span>
                    <span className="feature-title">Price</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="border1 rounded p-3 mt-4 bg-light1 bg-reviews">
              {/* DESKTOP ONLY */}
              <div className="d-none d-lg-flex align-items-center justify-content-between mb-1">
                <h5>Ratings and Reviews</h5>
                <div className="d-flex gap-2">
                  <button
                    className="bg_footer border-0 rounded-2 text-white p-md-2 mobilereview"
                    onClick={() => navigate(`/reviews/${finalId}`)} // ✅ finalId
                  >
                    View Reviews →
                  </button>
                  <button
                    className="bg_footer border-0 rounded-2 text-white p-md-2"
                    onClick={() => setShowReviewModal(true)}
                  >
                    Add Review <i className="bi bi-plus ps-2"></i>
                  </button>
                </div>
              </div>

              {/* DESKTOP rating row */}
              <div className="d-none d-lg-flex align-items-center gap-2">
                <span className="badge bg-success fs-6">
                  {BannerUser.rating || 3.6} ★
                </span>
                <span className="text-muted small">256 Ratings</span>
              </div>

              {/* MOBILE ONLY */}
              <div className="d-lg-none">
                <h5 className="mb-2">Ratings and Reviews</h5>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <span className="badge bg-success fs-6">
                    {BannerUser.rating || 3.6} ★
                  </span>
                  <span className="text-muted small">256 Ratings</span>
                </div>

                {/* ✅ IMAGES PEHLE - buttons se upar */}
                {reviews.length > 0 &&
                  reviews[0]?.review_images?.length > 0 && (
                    <div className="d-flex gap-2 mb-3 overflow-auto">
                      {reviews[0].review_images.slice(0, 3).map((img, i) => (
                        <img
                          key={i}
                          src={`${BASE_URL}/${img}`}
                          style={{
                            width: "70px",
                            height: "55px",
                            objectFit: "cover",
                            borderRadius: "6px",
                          }}
                          alt={`review-img-${i}`}
                        />
                      ))}
                    </div>
                  )}

                {/* ✅ BUTTONS BAAD MEIN - images ke neeche */}
                <div className="d-flex gap-2">
                  <button
                    className="bg_footer border-0 rounded-2 text-white review-action-btn"
                    onClick={() => navigate(`/reviews/${finalId}`)} // ✅ finalId
                  >
                    View Reviews →
                  </button>
                  <button
                    className="bg_footer border-0 rounded-2 text-white review-action-btn"
                    onClick={() => setShowReviewModal(true)}
                  >
                    Add Review <i className="bi bi-plus ps-1"></i>
                  </button>
                </div>
              </div>

              {/* DESKTOP images */}
              {reviews.length > 0 && reviews[0]?.review_images?.length > 0 && (
                <div className="d-none d-lg-flex gap-2 mt-2 overflow-auto">
                  {reviews[0].review_images.slice(0, 3).map((img, i) => (
                    <img
                      key={i}
                      src={`${BASE_URL}/${img}`}
                      style={{
                        width: "70px",
                        height: "55px",
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                      alt={`review-img-${i}`}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid px-5">
        <h3 className="text-decoration-underline">Description</h3>
        <hr />
        <div
          className="product-description mb-5"
          dangerouslySetInnerHTML={{
            __html: BannerUser.large_description || BannerUser.discription,
          }}
        />
      </div>

      {relatedProducts.length > 0 && (
        <CategorySection
          title="Similar Products"
          products={relatedProducts}
          categoryName={BannerUser.category_id}
        />
      )}

      {/* REVIEW MODAL */}
      {showReviewModal && (
        <div className="review-modal-overlay">
          <div className="review-modal">
            <h4>Add Review</h4>
            <select
              name="rating"
              onChange={handleReviewChange}
              className="form-control mb-2"
            >
              <option value="">Select Rating</option>
              <option value="5">5 ⭐</option>
              <option value="4">4 ⭐</option>
              <option value="3">3 ⭐</option>
              <option value="2">2 ⭐</option>
              <option value="1">1 ⭐</option>
            </select>
            <input
              type="text"
              name="review_title"
              placeholder="Review Title"
              className="form-control mb-2"
              onChange={handleReviewChange}
            />
            <textarea
              name="review_text"
              placeholder="Write review"
              className="form-control mb-2"
              onChange={handleReviewChange}
            />
            <input
              type="file"
              multiple
              className="form-control mb-2"
              onChange={handleReviewImages}
            />
            <div className="d-flex justify-content-end gap-2">
              <button
                className="btn btn-secondary"
                onClick={() => setShowReviewModal(false)}
              >
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSubmitReview}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      <DetailsSection2dynamic />
      <FooterNew />
    </>
  );
}

export default DetailsSection3;
